<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    <b-card>
      <template slot="header">
        <h3 class="inline float-left">Cadastrar cupom</h3>
        <b-button class="float-right" variant="success" @click="cadastrar">Confirmar Cadastro</b-button>
        <b-button class="float-right mr-3" variant="danger" @click="goBack">Cancelar Cadastro</b-button>
      </template>
      <b-row>
        <b-col cols="12">
          <b-card no-body class="no-margin-bottom">
            <div class="text-center">
              <h4>Selecione um filtro para realizar o envio dos cupons</h4>
              <small>Selecionado: {{ tabIndex == 0 ? 'Todos os clientes' : tabIndex == 1 ? 'Por Interesse' : 'Por Seleção' }}</small>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox v-model="expira" class="ml-3 mt-3" switch>Expira</b-form-checkbox>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Titulo">
            <b-form-input v-model="titulo" />
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Descrição">
            <b-form-input v-model="descricao" />
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Data Inicial" class="date-input">
            <datepicker
              class="form-control"
              v-model="datainicial"
              :language="ptBR"
              :format="customFormatter"
              :disabledDates="disabledDatesStart"
              :key="disabledDatesStart != null"
              @selected="mudaDataInicial"
              v-if="datainicial != null"
            ></datepicker>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Data Final" class="date-input">
            <datepicker
              v-bind:class="{ naoexpira: !expira }"
              class="form-control"
              v-model="datafinal"
              :language="ptBR"
              :format="customFormatter"
              :disabledDates="disabledDatesEnd"
              :key="disabledDatesEnd != null"
              :disabled="!expira"
              v-if="datafinal != null"
            ></datepicker>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Hora Inicial" class="time-input">
            <timeselector v-model="horaInicial" class="form-control" :displayFormat="'HH:mm'"></timeselector>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Hora Final" class="time-input">
            <timeselector v-model="horaFinal" class="form-control" :displayFormat="'HH:mm'" v-bind:class="{ naoexpira: !expira }" :disabled="!expira" ></timeselector>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Tipo Desconto">
            <b-form-select v-model="descontoSelecionado" :options="options"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Valor">
            <the-mask
              mask="##"
              v-model="valorDesconto"
              type="text"
              masked="true"
              class="form-control"
              placeholder="Valor do desconto"
            />
            <!-- <the-mask mask="##" v-model="valorDesconto" value="" type="text" masked="true" class="form-control" placeholder="Valor do desconto"/>             -->
          </b-input-group>
        </b-col>
        <b-col cols="12" class="mt-3">
          <b-tabs v-model="tabIndex">
            <b-tab title="Todos os clientes" active>
              <p class="texto-all-clientes">
                Enviará para todos os clientes cadastrados na plataforma mobile,
                que totaliza
                <strong>{{qtdClientesCadastrados}}</strong>
                {{qtdClientesCadastrados == 1 ? 'cliente' : 'clientes'}}.
              </p>
            </b-tab>
            <b-tab title="Por interesse">
              <p>Enviará de acordo com os interesses selecionados.</p>
              <b-row>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-form-group>
                    <b-input-group size="sm" prepend="Buscar">
                      <b-form-input
                        v-model="filterInteresses"
                        type="search"
                        id="filterInput"
                        placeholder="Digite para pesquisar"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          :disabled="!filterInteresses"
                          @click="filterInteresses = ''"
                        >Limpar</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-pagination
                    v-model="currentPageInteresses"
                    :total-rows="totalRowsInteresses"
                    :per-page="perPageInteresses"
                    align="fill"
                    size="sm"
                  ></b-pagination>
                </b-col>
              </b-row>
              <b-table
                :items="interesses"
                :fields="interessesFields"
                striped
                hover
                responsive="sm"
                bordered
                @row-clicked="selecionaInteresse"
                @head-clicked="selecionaInteressesHead"
                :filter="filterInteresses"
                :filterIncludedFields="filterOnInteresses"
                @filtered="onFilteredInteresses"
                :current-page="currentPageInteresses"
                :per-page="perPageInteresses"
              >
                <template slot="HEAD_selecionado">
                  <label class="form-checkbox">
                    <input
                      type="checkbox"
                      v-model="selecionarTodosOsInteresses"
                      @click="selecionaInteresses"
                    />
                    <i class="form-icon"></i>
                  </label>
                </template>
                <template slot="HEAD_descricao">Descrição</template>
                <template slot="selecionado" slot-scope="data">
                  <label class="form-checkbox">
                    <input type="checkbox" :value="data.item.id" v-model="interessesSelecionados" />
                    <i class="form-icon"></i>
                  </label>
                </template>
              </b-table>
            </b-tab>
            <b-tab title="Por seleção">
              <p>Seleção unitária de clientes.</p>
              <b-row>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-form-group>
                    <b-input-group size="sm" prepend="Buscar">
                      <b-form-input
                        v-model="filterClientes"
                        type="search"
                        id="filterInputSelecao"
                        placeholder="Digite para pesquisar"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          :disabled="filterInteresses != null && filterInteresses != ''"
                          @click="filterClientes = ''"
                        >Limpar</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-pagination
                    v-model="currentPageClientes"
                    :total-rows="totalRowsClientes"
                    :per-page="perPageClientes"
                    align="fill"
                    size="sm"
                  ></b-pagination>
                </b-col>
              </b-row>
              <b-table
                :items="clientes"
                :fields="clientesFields"
                striped
                hovers
                responsive="sm"
                bordered
                @row-clicked="selecionaCliente"
                @head-clicked="selecionaClientesHead"
                :filter="filterClientes"
                :filterIncludedFields="filterOnClientes"
                @filtered="onFilteredClientes"
                :current-page="currentPageClientes"
                :per-page="perPageClientes"
                show-empty
              >
                <template v-slot:empty="scope">
                  <h4>Não achamos nenhum registro.</h4>
                </template>
                <template v-slot:emptyfiltered="scope">
                  <center>
                    <h5>Não achamos nenhum registro em sua busca.</h5>
                  </center>
                </template>
                <template slot="HEAD_selecionado">
                  <label class="form-checkbox">
                    <input
                      type="checkbox"
                      v-model="selecionarTodosOsClientes"
                      @click="selecionaClientes"
                    />
                    <i class="form-icon"></i>
                  </label>
                </template>
                <template slot="HEAD_nome">Nome completo</template>
                <template slot="selecionado" slot-scope="data">
                  <label class="form-checkbox">
                    <input type="checkbox" :value="data.item.id" v-model="clientesSelecionados" />
                    <i class="form-icon"></i>
                  </label>
                </template>
                <template
                  slot="nome"
                  slot-scope="data"
                >{{ data.item.nome }} {{ data.item.sobrenome }}</template>
              </b-table>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import Timeselector from "vue-timeselector";
import Loading from "vue-loading-overlay";

import * as config from "@/config.json";
import axios from "axios";
import moment from "moment";
import tz from "moment-timezone";
import { TheMask } from "vue-the-mask";

export default {
  name: "cadastrar-cupom",
  components: {
    TheMask,
    Loading,
    moment,
    Datepicker,
    Timeselector
  },
  data: function() {
    return {
      isLoading: false,
      titulo: null,
      descricao: null,
      valorDesconto: null,
      expira: false,
      descontoSelecionado: null,
      options: [
        { value: null, text: "Selecione o tipo do desconto" },
        { value: 1, text: "Porcentagem" },
        { value: 2, text: "Valor" }
      ],
      datainicial: null,
      datafinal: null,
      ptBR: ptBR,
      disabledDatesStart: null,
      disabledDatesEnd: null,
      tabIndex: 0,
      qtdClientesCadastrados: 0,
      interesses: [],
      interessesFields: [
        "selecionado",
        "descricao",
        { key: "quantidade", label: "Clientes atingidos" }
      ],
      interessesSelecionados: [],
      selecionarTodosOsInteresses: false,
      clientes: [],
      clientesFields: ["selecionado", "nome"],
      clientesSelecionados: [],
      selecionarTodosOsClientes: false,
      filterInteresses: null,
      filterOnInteresses: [],
      currentPageInteresses: 1,
      perPageInteresses: 5,
      totalRowsInteresses: 1,
      filterClientes: null,
      currentPageClientes: 1,
      perPageClientes: 5,
      filterOnClientes: [],
      totalRowsClientes: 1,
      horaInicial: new Date(),
      horaFinal: new Date(),
      dados: []
    };
  },
  methods: {
    async retornaParametros() {
      await axios
        .get(
          `${
            config.default.servidor
          }/gerencial/retorna-parametros-configurar-distribuicao/${localStorage
            .getItem("enterprise_id")
            .toString()}`,
          {
            headers: {
              Accept: "application/json",
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          this.qtdClientesCadastrados = response.data.todosOsClientes;
          this.interesses = response.data.interesses;
          this.clientes = response.data.clientes;

          this.paginacaoInteresses();
          this.paginacaoClientes();
        });
    },
    paginacaoInteresses() {
      this.totalRowsInteresses = this.interesses.length;
    },
    paginacaoClientes() {
      this.totalRowsClientes = this.clientes.length;
    },
    onFilteredInteresses(filteredItems) {
      this.totalRowsInteresses = filteredItems.length;
      this.currentPageInteresses = 1;
    },
    onFilteredClientes(filteredItems) {
      this.totalRowsClientes = filteredItems.length;
      this.currentPageClientes = 1;
    },
    selecionaInteressesHead() {
      this.selecionaInteresses();
      this.selecionarTodosOsInteresses = !this.selecionarTodosOsInteresses;
    },
    selecionaInteresses() {
      this.interessesSelecionados = [];
      if (!this.selecionarTodosOsInteresses) {
        for (let i in this.interesses) {
          this.interessesSelecionados.push(this.interesses[i].id);
        }
      }
    },
    selecionaInteresse(record, index) {
      var arr = [];
      var lock = false;
      for (let i = 0; i < this.interessesSelecionados.length; i++) {
        const e = this.interessesSelecionados[i];
        if (e == record.id) {
          lock = true;
        } else {
          arr.push(e);
        }
      }
      if (!lock) {
        arr.push(record.id);
      }
      this.interessesSelecionados = arr;
    },
    selecionaClientesHead() {
      this.selecionaClientes();
      this.selecionarTodosOsClientes = !this.selecionarTodosOsClientes;
    },
    selecionaClientes() {
      this.clientesSelecionados = [];
      if (!this.selecionarTodosOsClientes) {
        for (let i in this.clientes) {
          this.clientesSelecionados.push(this.clientes[i].id);
        }
      }
    },
    selecionaCliente(record, index) {
      var arr = [];
      var lock = false;
      for (let i = 0; i < this.clientesSelecionados.length; i++) {
        const e = this.clientesSelecionados[i];
        if (e == record.id) {
          lock = true;
        } else {
          arr.push(e);
        }
      }
      if (!lock) {
        arr.push(record.id);
      }
      this.clientesSelecionados = arr;
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async mudaDataInicial(data) {
      if (data) {
        this.datainicial = new Date(data);
        if (moment(this.datainicial).isSameOrAfter(this.datafinal)) {
          this.datafinal = new Date(moment(this.datainicial).add(1, "days"));
          this.disabledDatesEnd.to = new Date(this.datainicial);
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    verificaCampos() {
      if (this.titulo == null || this.titulo == "") return false;
      if (this.descricao == null || this.descricao == "") return false;
      if (this.descontoSelecionado == null || this.descontoSelecionado == "")
        return false;
      if (this.valorDesconto == null || this.valorDesconto == "") return false;
      if (this.datainicial == null || this.datainicial == "") return false;
      if (this.expira) {
        if (this.datafinal == null || this.datafinal == "") return false;
        if (moment(this.datainicial).isAfter(this.datafinal)) return false;
      }
      return true;
    },
    async cadastrar() {
      this.isLoading = true;
      if (this.tabIndex == 1) {
        this.dados = this.interesses;
      } else if (this.tabIndex == 2) {
        this.dados = this.clientesSelecionados;
      }
      if (this.verificaCampos()) {
        if (this.valorDesconto > 15) {
          this.$dialogs.alert(
            `Valor de desconto superior a 15${
              this.descontoSelecionado == 1 ? "%" : " reais"
            }`
          );
        } else {
          await axios
            .put(
              `${config.default.servidor}/gerencial/cupom/`,
              {
                empresaid: localStorage.getItem("enterprise_id"),
                obj: {
                  tipo: this.tabIndex,
                  dados: this.dados,
                  titulo: this.titulo,
                  descricao: this.descricao,
                  tipoid: this.descontoSelecionado,
                  valorDesconto: this.valorDesconto,
                  datainicial: moment(this.datainicial).format("YYYY-MM-DD"),
                  datafinal: this.expira
                    ? moment(this.datafinal).format("YYYY-MM-DD")
                    : null,
                  horainicial: moment
                    .tz(this.horaInicial, "America/Sao_Paulo")
                    .format("HH:mm"),
                  horafinal: moment
                    .tz(this.horaFinal, "America/Sao_Paulo")
                    .format("HH:mm")
                }
              },
              {
                headers: {
                  Accept: "application/json",
                  Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                }
              }
            )
            .then(response => {
              if (response.status == 200) {
                let toast = this.$toasted.show("Cupom criado com sucesso!", {
                  theme: "toasted-primary",
                  position: "botton-center",
                  duration: 5000,
                  icon: "check",
                  iconPack: "fontawesome"
                });
                this.$router.push({ path: `/cupons` });
              }
            })
            .catch(error => {
              if (error.response.status == 403) {
                const msg = { title: "Aviso", size: "sm" };
                this.$dialogs
                  .alert(`Não foi possivel criar o cupom`, msg)
                  .then(res2 => {});
              }
            });
        }
      } else {
        this.$dialogs.alert(`Verifique todos os campos antes de continuar.`);
      }
      this.isLoading = false;
    }
  },
  async beforeMount() {
    this.isLoading = true;

    // Parametriza as datas no seu valor inicial
    this.datainicial = moment().format("YYYY-MM-DD hh:mm");
    this.datafinal = moment()
      .add(1, "days")
      .format("YYYY-MM-DD hh:mm");

    // Desabilita as datas iniciais que sejam menores do que hoje
    this.disabledDatesStart = {};
    this.disabledDatesStart.to = new Date(moment().subtract(1, "days"));

    // Desabilita as datas finais que sejam menores ou iguais a data inicial
    this.disabledDatesEnd = {};
    this.disabledDatesEnd.to = new Date(this.datainicial);

    await this.retornaParametros(); // Insere valores nas tabs

    this.isLoading = false;
  }
};
</script>



